import { DraftConfigurationColor, PrintType } from '@/types';
import { getClosestPrintColor } from './getClosestPrintColor';
import { isDigital } from './isDigital';
import { preventUnprintableColorCombinations } from './preventUnprintableColorCombinations';

/**
 * Converts an array of colors to the best matching print colors of the new print type.
 * If the new print type is digital we just transfer the fill since digital has no pre-defined print colors.
 * For all other print types we try to determine the closest matching print color.
 * @param {*} newPrintType API print type model
 * @param {*} colors array of either API print type colors or digital colors
 */
export const convertColors = (
  newPrintType: PrintType,
  colors: DraftConfigurationColor[]
): DraftConfigurationColor[] => {
  if (isDigital(newPrintType)) {
    return colors.map(({ fill }) => ({ fill }));
  }

  const newColors = colors.map((c) => getClosestPrintColor(newPrintType, c.fill));
  preventUnprintableColorCombinations(newColors, newColors[0]);

  return newColors;
};
